import { z } from 'zod';
/**
 * Verträge für „Abteilungen & Positionen“ im Personalmanagement (KON-236). Der Mandant legt hier die Struktur seines Unternehmens fest. Die Positionen sind die Auswahl beim Anlegen
 * eines Mitarbeiters und in der Schichtplanung. Mitarbeiter führen Abteilung und Position weiterhin als Text, damit vorhandene Daten gültig bleiben, die Namen aus dieser Struktur
 * sind die zulässigen Werte.
 */
const structureName = z.string().trim().min(1, 'Bitte einen Namen eingeben').max(100, 'Höchstens 100 Zeichen');
export const createDepartmentInput = z.object({ name: structureName });
export const updateDepartmentInput = z.object({ name: structureName });
export const createPositionInput = z.object({ name: structureName, departmentId: z.uuid('Ungültige Abteilung').nullable().optional() });
export const updatePositionInput = z.object({ name: structureName.optional(), departmentId: z.uuid('Ungültige Abteilung').nullable().optional() });
//# sourceMappingURL=structure.js.map